export async function campaignApi(path, body) {
    const csrf =
        document.cookie
            .split('; ')
            .find((v) => v.startsWith('csrftoken='))
            ?.split('=')
            .slice(1)
            .join('=') || '';
    const response = await fetch(`/api/inspection-campaigns/${path}`, {
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrf },
        method: body === undefined ? 'GET' : 'POST',
        ...(body === undefined ? {} : { body: JSON.stringify(body) })
    });
    if (
        response.redirected ||
        !response.headers.get('content-type')?.includes('application/json')
    ) {
        throw new Error(
            'Access changed or the session expired. Refresh this page.'
        );
    }
    const data = await response.json();
    if (!response.ok) {
        const error = new Error(
            data.error || 'The request failed. Reload the review.'
        );
        error.status = response.status;
        throw error;
    }
    return data;
}

export function statusLabel(value) {
    return (
        {
            unreviewed: 'Not started',
            needs_review: 'Needs review',
            reviewed: 'Complete',
            cannot_assess: 'Cannot assess',
            unavailable: 'Unavailable'
        }[value] || value
    );
}

export function captureMatches(target, views = []) {
    return Boolean(
        target?.dataset_uuid &&
        target?.view_uuid &&
        views.length === 1 &&
        views[0].datasetPackage?.uuid === target.dataset_uuid &&
        views[0].viewUUID === target.view_uuid &&
        ['inspection_view', 'thermal_inspection_view'].includes(
            views[0].component
        ) &&
        !views[0].state
    );
}

export function nextReviewTarget(targets, targetId) {
    const index = targets.findIndex((t) => t.uuid === targetId);
    return [...targets.slice(index + 1), ...targets.slice(0, index + 1)].find(
        (t) =>
            t.uuid !== targetId &&
            ['unreviewed', 'needs_review'].includes(t.status)
    );
}
